import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import {AgGridReact} from "ag-grid-react";
import formBuilderService from "../../../../../services/web/form-builder-service.js";
import moment from "moment";
import Button from "../../../../../components/button/button.jsx";
import {FaEye} from "react-icons/fa";
import aggridUtils from "../../../../../utils/aggrid-utils.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const FormSubmissions = ({templateId, externalId}) => {
    const {data, refetch} = useQuery({
        queryFn: () => formBuilderService.submissionList(templateId, externalId),
        queryKey: ["completed", {open}],
        enabled: templateId !== undefined,
    })

    useEffect(() => {
        if (!templateId) return

        refetch()
    }, [templateId])

    const gridRef = useRef(undefined)

    const [columnDefs,] = useState([
        {headerName: "Preenchido por", field: "namewar", flex: 1, valueFormatter: ({data}) => data.namewar || data.name, comparator: aggridUtils.nullLastComparator},
        {headerName: "Data/hora", field: "created_at", flex: 1, sort: "desc", valueFormatter: ({value}) => moment(value).format("DD/MM/YYYY HH:mm")},
        {
            headerName: "",
            field: "",
            cellRenderer: ({node}) => (
                <div className="text-center w-full h-full content-center">
                    <Button onClick={() => window.open(`${API_KEEPER}/ged/attach/print/pdf/${node.data.pdf_id}`)}>
                        <FaEye />
                    </Button>
                </div>
            ),
            width: 80
        }
    ])

    const defaultColDef = useMemo(() => ({resizable: false}), [])

    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    return (
        <div className={`aggrid-row-pointer`} style={{height: "calc(100vh - 220px)"}}>
            <AgGridReact
                ref={gridRef}
                rowHeight={40}
                rowData={data ?? []}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={false}
                suppressCellFocus={true}
                pagination
                gridOptions={{localeText: aggridUtils.localization()}}
                theme={theme}
            />
        </div>
    );
};

export default FormSubmissions;